import firebase from "firebase/app";
import 'firebase/firestore';
import calcRating from "@/store/modules/utils/calcRating";

const COLLECTION_COMMENTS = process.env.VUE_APP_COLLECTION_COMMENTS;
const COLLECTION_COMPANIES = process.env.VUE_APP_COLLECTION_COMPANIES;

export default {
    namespaced: true,
    state: {
        comments: [],
        lastVisible: null,
        company: null
    },
    getters: {
        getComments: state => state.comments,
        getCompany: state => state.company
    },
    mutations: {
        SET_COMPANY(state, company) {
            state.company = company;
        },
        UPDATE_COMPANY_RATING(state, rating) {
            state.company.social.rating = rating;
        },
        SET_COMMENT(state, comments) {
            state.comments = comments;
        },
        SET_LAST_VISIBLE(state, value) {
            state.lastVisible = value;
        },
        UPDATE_COMMENT(state, payload) {
            Object.assign(state.comments[payload.index], payload.comment);
        },
        REMOVE_COMMENT(state, comment) {
            state.comments = state.comments.filter(item => item.id !== comment.id);
        }
    },
    actions: {
        async loadCompany({commit}, company_id) {
            const doc = await firebase.firestore().collection(COLLECTION_COMPANIES).doc(company_id).get();
            commit('SET_COMPANY', doc.data());
        },
        async loadComments({commit, state}, params) {
            const { orderBy, refreshPage, itemsPerPage } = params;
            const first = refreshPage
                ? firebase.firestore().collection(COLLECTION_COMMENTS)
                    .orderBy(...orderBy)
                    .limit(refreshPage ? itemsPerPage * 2 : itemsPerPage)
                : firebase.firestore().collection(COLLECTION_COMMENTS)
                    .orderBy(...orderBy)
                    .startAfter(state.lastVisible)
                    .limit(refreshPage ? itemsPerPage * 2 : itemsPerPage)

            const querySnapshot = await first.get().then(snapshot => {
                const lastVisible = snapshot.docs[snapshot.docs.length - 1];
                commit('SET_LAST_VISIBLE', lastVisible);
                return snapshot;
            });
            const comments = querySnapshot.docs.map(doc => {
                const comment = doc.data();
                comment.id = doc.id;
                return comment;
            });
            if (refreshPage) {
                commit('SET_COMMENT', comments);
            } else {
                commit('SET_COMMENT', [...comments, ...state.comments]);
            }
        },
        async updateComment({commit, state}, payload) {
            const { id, company_id, date_added, name, message } = payload.comment;
            const publicComment = {
                id, company_id, date_added, name, message,
                rating: payload.comment.rating
            };

            const comments = payload.comment.approved
                ? [publicComment, ...state.company.social.comments]
                    .sort((a, b) => b.date_added.seconds - a.date_added.seconds)
                : state.company.social.comments.filter(comment => comment.id !== payload.comment.id);

            const rating = payload.comment.approved
                ? calcRating([...state.company.social.comments, payload.comment])
                : calcRating(state.company.social.comments.filter(comment => comment.id !== payload.comment.id));

            await firebase.firestore().collection(COLLECTION_COMPANIES).doc(payload.comment.company_id)
                .update({ social: { comments, rating }})
                .then(() => {
                    payload.comment.date_approved = payload.comment.approved
                        ? firebase.firestore.Timestamp.fromDate(new Date())
                        : null;
                    firebase.firestore().collection(COLLECTION_COMMENTS).doc(payload.comment.id).set(payload.comment);
                }).then(() => {
                    const increment = payload.comment.approved ? -1 : 1;
                    firebase.firestore().collection(process.env.VUE_APP_COLLECTION_UTILS)
                        .doc(process.env.VUE_APP_COLLECTION_COMMENTS)
                        .update({
                            unapproved: firebase.firestore.FieldValue.increment(increment),
                            timestamp: firebase.firestore.Timestamp.fromDate(new Date())
                        });
                    commit('dashboard/SET_COMMENTS_UTILS_PROP', { prop: 'unapproved', value: increment }, { root: true });
                });
            commit('UPDATE_COMMENT', payload);
            commit('UPDATE_COMPANY_RATING', rating);
        },
        async removeComment({commit, state}, comment) {
            const increment = comment.approved ? -1 : 0;
            await firebase.firestore().collection(COLLECTION_COMPANIES).doc(comment.company_id)
                .update({
                    social: {
                        comments: state.company.social.comments.filter(com => com.id !== comment.id),
                        rating: calcRating(state.company.social.comments.filter(com => com.id !== comment.id))
                    }
                }).then(() => {
                    firebase.firestore().collection(COLLECTION_COMMENTS).doc(comment.id).delete();
                }).then(() => {
                    firebase.firestore().collection(process.env.VUE_APP_COLLECTION_UTILS)
                        .doc(process.env.VUE_APP_COLLECTION_COMMENTS)
                        .update({
                            length: firebase.firestore.FieldValue.increment(-1),
                            unapproved: firebase.firestore.FieldValue.increment(increment),
                            timestamp: firebase.firestore.Timestamp.fromDate(new Date()),
                        });
                });
            commit('REMOVE_COMMENT', comment);
            commit('dashboard/SET_COMMENTS_UTILS_PROP', { prop: 'length', value: -1 }, { root: true });
            commit('dashboard/SET_COMMENTS_UTILS_PROP', { prop: 'unapproved', value: -1 }, { root: true });
        }
    }
}
